module.exports = __webpack_public_path__ + "img/map_pin_home5.1941ac72.svg";